"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MODEL_COLLECTION: function() {
        return MODEL_COLLECTION;
    },
    RESET: function() {
        return RESET;
    }
});
_export_star(require("./appearance"), exports);
_export_star(require("./arenas"), exports);
_export_star(require("./brand"), exports);
_export_star(require("./championship"), exports);
_export_star(require("./contract"), exports);
_export_star(require("./draft"), exports);
_export_star(require("./faction"), exports);
_export_star(require("./feud"), exports);
_export_star(require("./game"), exports);
_export_star(require("./injury"), exports);
_export_star(require("./mail"), exports);
_export_star(require("./notification"), exports);
_export_star(require("./production"), exports);
_export_star(require("./reigns"), exports);
_export_star(require("./rumble"), exports);
_export_star(require("./segment"), exports);
_export_star(require("./wrestler"), exports);
_export_star(require("./show"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
const MODEL_COLLECTION = "MODEL_COLLECTION";
const RESET = "RESET";
